import React from "react";
import { FormattedMessage } from "react-intl";
import { ErrorAlert } from "theme/components/molecules/Alert";
import Stack from "theme/components/atoms/Layout/Stack";
import MiniCartTitle from "./MiniCartTitle";

const MiniCartContentError = () => {
  return (
    <div className="page-content">
      <div className="container">
        <Stack size="4">
          <MiniCartTitle />
          <ErrorAlert>
            <FormattedMessage
              id="modules.Cart.MiniCart.MiniCartContent.error"
              defaultMessage="We couldn't reach your cart. Please try again and if the problem persists contact us."
            />
          </ErrorAlert>
        </Stack>
      </div>
    </div>
  );
};

export default MiniCartContentError;
